module.exports = __webpack_public_path__ + "img/canvax_login_bg_.fd8f1d60.jpg";